/* eslint-disable react/forbid-prop-types, react/require-default-props */
import React from "react";
import PropTypes from "prop-types";
import "./skeleton.css";

const RADIUS_DEFAULTS = { rect: 6, circle: 9999, bar: 999 };
const HEIGHT_DEFAULTS = { rect: 16, circle: null, bar: 6 };

const SkeletonLine = ({ variant, width, height, radius, className, style }) => {
  const computedRadius = radius ?? RADIUS_DEFAULTS[variant] ?? RADIUS_DEFAULTS.rect;
  const computedHeight = height ?? (variant === "circle" ? width : HEIGHT_DEFAULTS[variant]);
  return (
    <span
      className={`gmb-skel ${className}`}
      style={{
        width: width ?? "100%",
        height: computedHeight,
        borderRadius: computedRadius,
        ...style,
      }}
    />
  );
};

/**
 * Shared shimmer skeleton placeholder, generalized from the .gmb-skel classes
 * already used by CustomWidget/LeaderboardTable (see skeleton.css).
 */
const Skeleton = ({
  variant = "rect",
  width,
  height,
  radius,
  count = 1,
  className = "",
  style = {},
}) => {
  if (count <= 1) {
    return (
      <SkeletonLine
        variant={variant}
        width={width}
        height={height}
        radius={radius}
        className={className}
        style={style}
      />
    );
  }
  return (
    <span className="gmb-skel-group">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonLine
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          variant={variant}
          width={width}
          height={height}
          radius={radius}
          className={className}
          style={style}
        />
      ))}
    </span>
  );
};

Skeleton.propTypes = {
  variant: PropTypes.oneOf(["rect", "circle", "bar"]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  radius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Skeleton;
